export const COMMUNICATION_GATE_THERAPY_REPORT_COMPLETION_REMINDER =
  'therapyReportCompletionReminderEnabled'
export const COMMUNICATION_GATE_PAYOUT_CYCLE_ADMIN_INTIMATION =
  'payoutCycleAdminIntimationEnabled'
export const COMMUNICATION_GATE_PAYOUT_CYCLE_PRACTITIONER_INTIMATION =
  'payoutCyclePractitionerIntimationEnabled'
export const COMMUNICATION_GATE_PAYOUT_CYCLE_TRANSFER_INITIATION =
  'payoutCycleTransferInitiationIntimationEnabled'
export const COMMUNICATION_GATE_PAYOUT_CYCLE_TRANSFER_COMPLETION =
  'payoutCycleTransferCompletionIntimationEnabled'

export const PRACTITIONER_COMMUNICATION_GATE_DEFAULTS = {
  [COMMUNICATION_GATE_THERAPY_REPORT_COMPLETION_REMINDER]: false,
  [COMMUNICATION_GATE_PAYOUT_CYCLE_ADMIN_INTIMATION]: false,
  [COMMUNICATION_GATE_PAYOUT_CYCLE_PRACTITIONER_INTIMATION]: false,
  [COMMUNICATION_GATE_PAYOUT_CYCLE_TRANSFER_INITIATION]: false,
  [COMMUNICATION_GATE_PAYOUT_CYCLE_TRANSFER_COMPLETION]: false,
}

export const PAYOUT_CYCLE_COMMUNICATION_GATE_ITEMS = [
  {
    key: COMMUNICATION_GATE_PAYOUT_CYCLE_ADMIN_INTIMATION,
    label: 'Finance report intimation',
    description: 'Emails ROLE_FINANCE_ADMIN and ROLE_FINANCE users when the cycle PDF is ready for review.',
  },
  {
    key: COMMUNICATION_GATE_PAYOUT_CYCLE_PRACTITIONER_INTIMATION,
    label: 'Practitioner payout report',
    description: 'Sends the practitioner payout report notification by email and WhatsApp.',
  },
  {
    key: COMMUNICATION_GATE_PAYOUT_CYCLE_TRANSFER_INITIATION,
    label: 'Transfer initiation alert',
    description: 'Emails ROLE_FINANCE_ADMIN and ROLE_FINANCE users when transfers should be initiated.',
  },
  {
    key: COMMUNICATION_GATE_PAYOUT_CYCLE_TRANSFER_COMPLETION,
    label: 'Transfer completion alert',
    description: 'Emails ROLE_FINANCE_ADMIN and ROLE_FINANCE users when transfers should be completed or confirmed.',
  },
]

export function getPractitionerCommunicationGateSettings(source = {}) {
  const direct = source?.communicationGateSettings || {}
  const nested = source?.practitioner?.communicationGateSettings || {}
  return {
    ...PRACTITIONER_COMMUNICATION_GATE_DEFAULTS,
    ...direct,
    ...nested,
  }
}

export function buildPractitionerCommunicationGateSettings(currentSettings = {}, key, enabled) {
  return {
    ...PRACTITIONER_COMMUNICATION_GATE_DEFAULTS,
    ...(currentSettings || {}),
    [key]: Boolean(enabled),
  }
}
